import React, { useMemo, useCallback } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';

import Tabs from '../../components/ui/Tabs';
import ApiKeysTab from './ApiKeysTab';
import WebhooksTab from './WebhooksTab';
import SandboxTab from './SandboxTab';
import { isSandboxEnvironment } from '../../utils/environment';

// Entegrasyonlar — PA (Public API) modülünün yönetim yüzeyi (tasarım belgesi §6.5, §8).
// Sekmeler: API Anahtarları (Plan 01), Webhook'lar (Plan 03 — PM ayarlarındaki Faz I
// sekmesinin yerini aldı; webhook artık modüller arası olduğundan PA'dadır) ve Test Ortamı (aşağıda).
//
// Tek sekmede sekme çubuğu ÇİZİLMEZ: sekme adı ile tablonun kendi başlığı alt alta aynı
// metni tekrarlardı (başlık yalnız DataTable'da — UI altın kuralı). İki sekmeyle çubuk görünür.
//
// ?tab= DERİN BAĞLANTI (inceleme D2): "webhook ucu devre dışı bırakıldı" bildirimi
// (pa.webhook_disabled) /integrations?tab=webhooks'a götürür — ilk sekmeye (API Anahtarları)
// inseydi İK sorunu aramak zorunda kalırdı. Etkin sekme adresin kendisidir: sekme değişince
// adres replace edilir (geri tuşu geçmişi kirlenmez, bağlantı paylaşılabilir). Bilinmeyen
// değer ilk sekmeye düşer.
//
// TEST ORTAMI sekmesi (sandbox self-servis giriş): canlı panelden test ortamına geçiş. Test ortamının
// KENDİ arayüzünde (REACT_APP_ENVIRONMENT=sandbox) listede YOKTUR — sandbox içinden "test ortamına
// git" anlamsızdır; oradaki ?tab=sandbox bağlantısı da ilk sekmeye düşer.
const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

const TABS = [
  { key: 'apiKeys', labelKey: 'apiKeys.title', Component: ApiKeysTab },
  { key: 'webhooks', labelKey: 'webhooks.tabLabel', Component: WebhooksTab },
  { key: 'sandbox', labelKey: 'sandboxEnv.tabLabel', Component: SandboxTab },
];

const SANDBOX_ENV_TABS = TABS.filter((tab) => tab.key !== 'sandbox');

// Ortam bayrağı her çağrıda okunur (modül yüklenirken değil) — testler kipi değiştirebilsin.
// İki sabit diziden biri döner: referans kararlıdır (useMemo bağımlılığı).
const visibleTabs = () => (isSandboxEnvironment() ? SANDBOX_ENV_TABS : TABS);

export default function IntegrationsPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const available = visibleTabs();
  const requested = new URLSearchParams(location.search).get('tab');
  const activeTab = available.some((tab) => tab.key === requested) ? requested : available[0].key;

  const setActiveTab = useCallback((key) => {
    const params = new URLSearchParams(location.search);
    params.set('tab', key);
    history.replace({ pathname: location.pathname, search: `?${params.toString()}` });
  }, [history, location.pathname, location.search]);

  const tabs = useMemo(
    () => available.map((tab) => ({ key: tab.key, label: t(tab.labelKey) })),
    [t, available],
  );
  // activeTab yukarıda doğrulandı (bilinmeyen → ilk sekme) — tek düşme noktası orasıdır.
  const Active = available.find((tab) => tab.key === activeTab).Component;

  return (
    <Container>
      {tabs.length > 1 && <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />}
      <Active />
    </Container>
  );
}
